var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"itemsList":_vm.navbarData}}),_c('main',{staticClass:"main-container"},[_vm._t("default"),_vm._v("> "),_c('Footer',{attrs:{"logo":"","items":_vm.footerItems,"social":_vm.footerSocial}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }